const locale = {
	name:'Name',
	email:'Email',
	project:'Project',
	actions:'Actions',
	create_member: 'Add Member',
	all_users: 'All Members',
	members: 'Members',
	filter: 'Filter',
	filter_by: 'Filter by',
	reset_filters: 'Reset Filters',
	member_type: 'Member Type',
	position:'Position',
	group_type: 'Group Type',
	project_branch: 'Project Branch',
	affiliation: 'Affiliation',
	account_status: 'Account Status',
	status:'Status',
	search_member: 'Search Member',
	members_title: 'Members',
	edit_details: 'Edit Details',
	change_password: 'Change Password',
	activate_account: 'Activate Account',
	deactivate_account: 'Deactivate Account',
	recover_account: 'Recover Account',
	add_member: 'Add Member',
	companies: 'Companies',
	active:'Active',
	inactive: 'Inactive',
	unverified: 'Unverified',
	deleted: 'Deleted',
	export: 'Export',
	cancel:'Cancel',
	submit:'Submit',
	delete:'Delete',
	update:'Update',
	select_member_type:'Select Member Type',
	select_group_type:'Select Group Type',
	select_affiliation:'Select Affiliation',
	select_user_position: 'Select User Position',
	select_project:'Select Project',
	enter_name:'Enter Name',
	enter_email: 'Enter Email',
	delete_account: 'Delete Account',
	deactivate: 'Deactivate',
	do_you_want_to_activate_this_account: 'Do you want to activate this account?',
	do_you_want_to_deactivate_this_account: 'Do you want to deactivate this account?',
	do_you_want_to_delete_this_account: 'Do you want to delete this account?',
	do_you_want_to_recover_this_account: 'Do you want to recover this account?',
	no_matching_records_found:'No matching records found!',
	new_password: 'New Password',
	enter_new_password: 'Enter New Password',
	confirm_password: 'Confirm Password',
	update_password: 'Update Password',
	enter_confirm_password: 'Enter Confirm Password',
	this_email_already_exist:'This email already exist!',
	resend_verify_email: 'Resend verify Email',
	local_name:'Local Name',
	reset_project: 'Reset',
	remove_from_project:'Remove from Project',
	do_you_want_to_remove:'Do you want to remove',
	from_this_project: 'from this project ?',
	please_select_project: 'Please select Project',
	please_select_project_branch: 'Please select Project Branch',
	view_project:'View Project',
	updated_succesfully: 'Updated Succesfully',
	do_you_want_to_remove_this_project: 'Do you want to remove this project :',
	map_member: 'Map Member',
	search_project: 'Search Project',
	do_you_want_to_remove_this_member:'Do you want to remove this member :',
	loading : 'Loading...',
	created_succesfully: 'Created Succesfully',
	invalid_email: 'Invalid Email',
	invalid_name: 'Invalid Name',
	project_code : 'Project Code:',
};

export default locale;
